<template>
  <div class="mb-4 mt-7">
    <SelectModuleButton
      class="py-1"
      data-qa="service_select_synonym_button"
      :title="selectedSynonym.name"
      :subtitle="getFormattedPrice(selectedSynonym.price)"
      @click="handleClickSelect"
    >
      <template #subtitle>
        <template v-if="isUsedClub">
          <span
            v-if="formattedSelectedSynonym.priceWithDiscount"
            class="error--text pr-1"
          >
            {{ getFormattedPrice(formattedSelectedSynonym.priceWithDiscount) }}
            <template v-if="selectedSynonym.duration">
              &bull; {{ getDurationText(selectedSynonym.duration) }}
            </template>
          </span>
          <span :class="{ 'text-decoration-line-through': formattedSelectedSynonym.priceWithDiscount }">
            {{ getFormattedPrice(selectedSynonym.price) }}
            <template v-if="selectedSynonym.duration">
              &bull; {{ getDurationText(selectedSynonym.duration) }}
            </template>
          </span>
        </template>
        <template v-else>
          {{ getFormattedPrice(selectedSynonym.price) }}
          <template v-if="selectedSynonym.duration">
            &bull; {{ getDurationText(selectedSynonym.duration) }}
          </template>
        </template>
      </template>
    </SelectModuleButton>
    <CoreDialog
      v-model="isVisibleError"
      data-qa="service_select_synonym_error"
      size="sm"
      title="Произошла ошибка"
    >
      <div class="text-body-1 text-secondary--text">
        Попробуйте ещё раз.
      </div>
      <template #actions>
        <v-btn
          data-qa="modal-actions-btn-close"
          color="primary"
          text
          @click="isVisibleError = false"
        >
          Понятно
        </v-btn>
      </template>
    </CoreDialog>
    <SideMenu
      :title="modalTitle"
      side-menu-width="650px"
      :is-btn-back="!isStackRoot"
      :value="isVisibleModal"
      side-menu-auto-scroll-y
      @side-menu:click-close="handleClickModalBack"
      @side-menu:click-back="handleClickModalBack"
    >
      <template #header-bottom>
        <SynonymListSearch
          ref="synonymListSearchComponent"
          class="pb-2"
          :synonym-data="ajaxSynonymData"
          :is-loading="isLoadingSynonym"
          @search:found-results="handleSearchFoundResults"
        />
      </template>
      <SynonymListSearchEmpty
        v-if="isSearchResultsEmpty"
      />
      <SynonymListItems
        v-else
        :is-used-club="isUsedClub"
        :synonym-list="activeSynonymList"
        :diagnostic-level="diagnosticLevel"
        :is-loading-synonym="isLoadingSynonym"
        :is-search-results="hasSearchResults"
        @synonym-list:click-item="handleClickSynonymItem"
      />
    </SideMenu>
  </div>
</template>

<script>
import vuetify from 'www/modules/vuetify-plugin'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import SideMenu from 'www/vue_components/desktop/core/SideMenu.vue'
import SelectModuleButton from 'www/vue_components/common/SelectModule/SelectModuleModal/components/common/SelectModuleButton.vue'
import SynonymListSearch from 'www/vue_components/common/SynonymList/components/common/SynonymListSearch.vue'
import SynonymListSearchEmpty from 'www/vue_components/common/SynonymList/components/common/SynonymListSearchEmpty.vue'
import SynonymListItems from 'www/vue_components/common/SynonymList/components/common/SynonymListItems.vue'
import SynonymListLogic from 'www/vue_components/common/SynonymList/mixins/SynonymListLogic'

export default {
  name: 'SynonymList',
  vuetify,
  components: {
    CoreDialog,
    SideMenu,
    SelectModuleButton,
    SynonymListSearch,
    SynonymListSearchEmpty,
    SynonymListItems,
  },
  mixins: [
    SynonymListLogic,
  ],
}
</script>
